import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { Languages, typedDictionary } from '@sbercloud/ft-config-i18n';
import { I18N_NS } from './constants';
import { en } from './locales/en-GB';
import { ru } from './locales/ru-RU';
import { mergeTranslations, normalizeTexts, useCommonTranslations } from './utils';
export { useCommonTranslations, mergeTranslations, I18N_NS };

/**
 * @deprecated use useCommonTranslations instead
 */
export var useCptTranslation = useCommonTranslations;
export var ruTranslations = normalizeTexts(ru);
export var enTranslations = normalizeTexts(en);
export var commonTranslations = typedDictionary(ruTranslations);

/**
 * @deprecated use commonTranslations instead
 */
export var cptTranslations = commonTranslations;
export var additionalTranslationsResources = _defineProperty(_defineProperty({}, Languages.Ru, _defineProperty({}, I18N_NS, ruTranslations)), Languages.En, _defineProperty({}, I18N_NS, enTranslations));